import React from 'react';
import { Cmi5Context } from '../contexts/cmi5Context';

export const useCmi5 = () => React.useContext(Cmi5Context);
